import {setPreviewCacheAuth} from '@ergeon/cad/exports/previewCacheAuth';
import authService from './auth';

export const wirePreviewCacheAuth = () => {
  setPreviewCacheAuth(() => (authService.getToken() ? {Authorization: authService.getAuthHeader()} : undefined));
};
